var ShowCardTemplate = function ShowCardTemplate(app, mod, this_obj) {
  var html = "\n  <div class=\"ts-overlay\">\n  <h1>".concat(this_obj.title, "</h1>\n  <div class=\"ts-body\">\n  <div class=\"cardlist-container\">").concat(mod.returnCardList(cards), "</div>");
  if (this_obj.cards.length == 0) {
    html = "<div style=\"text-align:center; margin: auto;\">\n            There are no cards to display\n            </div>";
  }
  html += '</div></div>';
  return html;
};
module.exports = ShowCardTemplate;